import { jsx as _jsx } from "react/jsx-runtime";
import FullPreview from "./FullPreview";
import PartialPreview from "./PartialPreview";
import RwaPreview from "./RwaPreview";
import WalletFullPreview from "./WalletFullPreview";
import WalletPartialPreview from "./WalletPartialPreview";
const StrategyPreview = ({ result, underlying }) => {
    switch (result.strategy) {
        case "full":
        case "loss-policy":
            return result.preview ? (_jsx(FullPreview, { preview: result.preview, underlying: underlying })) : null;
        case "partial":
        case "deleverage":
            return result.preview ? (_jsx(PartialPreview, { preview: result.preview, balancesBefore: result.balancesBefore, underlying: underlying })) : null;
        case "rwa-via-stablecoins":
            return result.preview ? _jsx(RwaPreview, { preview: result.preview }) : null;
        case "wallet-full":
            return result.preview ? (_jsx(WalletFullPreview, { preview: result.preview })) : null;
        case "wallet-partial":
            return result.preview ? (_jsx(WalletPartialPreview, { preview: result.preview, balancesBefore: result.balancesBefore, underlying: underlying })) : null;
        default:
            return null;
    }
};
export default StrategyPreview;
